import { UnderlyingsDatesKey, UnderlyingsDatesPayload } from 'state/underlyingsDates/underlyingsDatesState.model';

export const buildUnderlyingsDatesKey = (underlyingsDatesPayload: UnderlyingsDatesPayload): UnderlyingsDatesKey => {
  return {
    underlyingBloombergCode: underlyingsDatesPayload.underlyingBloombergCode,
    productType: underlyingsDatesPayload.instrumentName ?? underlyingsDatesPayload.productType,
    productSubType: underlyingsDatesPayload.instrumentContractName ?? underlyingsDatesPayload.productSubType,
  };
};
export const buildUnderlyingsDatesCompositeKey = (underlyingsDatesKey: UnderlyingsDatesKey) => {
  return [
    underlyingsDatesKey.underlyingBloombergCode,
    underlyingsDatesKey.productType,
    underlyingsDatesKey.productSubType,
  ].join('|');
};
